<template>
  <v-dialog
      v-model="dialogInterno"
      max-width="600px"
      persistent
      scrollable
  >
    <v-card class="form-dialog">
      <!-- Cabeçalho -->
      <v-card-title class="dialog-header pa-4">
        <div class="d-flex align-center flex-grow-1">
          <div class="icon-wrapper-medium mr-3">
            <v-icon color="white" size="28">
              {{ modoEdicao ? 'mdi-pencil' : 'mdi-plus' }}
            </v-icon>
          </div>
          <div class="header-title">
            {{ modoEdicao ? 'Editar Categoria' : 'Nova Categoria' }}
          </div>
        </div>
        <v-btn
            icon
            color="white"
            @click="fechar"
            :disabled="salvando"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Conteúdo -->
      <v-card-text class="pa-6 form-content">
        <v-form ref="form" v-model="formularioValido" @submit.prevent="salvar">
          <!-- Nome da Categoria -->
          <div class="form-group mb-5">
            <label class="form-label">
              Nome da Categoria
              <span class="required">*</span>
            </label>
            <v-text-field
                v-model="formulario.nome"
                placeholder="Ex: Segurança do Trabalho"
                outlined
                dense
                :rules="regras.nome"
                :disabled="salvando"
                maxlength="100"
                counter
                hide-details="auto"
            >
              <template v-slot:prepend-inner>
                <v-icon color="#64748b" size="20">mdi-format-title</v-icon>
              </template>
            </v-text-field>
          </div>

          <!-- Cor da Categoria -->
          <div class="form-group mb-5">
            <label class="form-label">
              Cor da Categoria
              <span class="required">*</span>
            </label>

            <v-card outlined class="color-picker-card">
              <v-card-text class="pa-4">
                <div class="d-flex align-center mb-4">
                  <!-- Color Picker Button -->
                  <div class="mr-4">
                    <v-menu
                        v-model="menuCor"
                        :close-on-content-click="false"
                        offset-y
                        :disabled="salvando"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            :color="formulario.cor"
                            height="60"
                            width="60"
                            elevation="2"
                            :disabled="salvando"
                            class="color-button"
                        >
                          <v-icon color="white" size="28">mdi-palette</v-icon>
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-text>
                          <v-color-picker
                              v-model="formulario.cor"
                              mode="hexa"
                              hide-inputs
                              show-swatches
                              :swatches="coresSugeridas"
                          ></v-color-picker>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </div>

                  <!-- Input da Cor -->
                  <div class="flex-grow-1">
                    <v-text-field
                        v-model="formulario.cor"
                        label="Código da Cor"
                        placeholder="#FF5733"
                        outlined
                        dense
                        :rules="regras.cor"
                        :disabled="salvando"
                        maxlength="7"
                        hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <div
                            class="color-preview-small"
                            :style="{ backgroundColor: formulario.cor }"
                        ></div>
                      </template>
                    </v-text-field>
                    <div class="field-hint">
                      Clique no botão colorido ou digite o código hexadecimal
                    </div>
                  </div>
                </div>

                <!-- Cores Rápidas -->
                <div>
                  <div class="color-swatches-label">Cores Sugeridas:</div>
                  <div class="color-swatches">
                    <v-btn
                        v-for="cor in coresSugeridas[0]"
                        :key="cor"
                        small
                        icon
                        class="swatch-button"
                        :style="{ backgroundColor: cor }"
                        @click="formulario.cor = cor"
                        :disabled="salvando"
                    >
                      <v-icon v-if="formulario.cor === cor" small color="white">
                        mdi-check
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>

          <!-- Ícone da Categoria -->
          <div class="form-group mb-5">
            <IconPicker
                v-model="formulario.icone"
                label="Ícone da Categoria"
                :preview-color="formulario.cor"
                :disabled="salvando"
                :error-messages="erroIcone"
                required
            />
          </div>

          <!-- Preview da Categoria -->
          <div class="form-group">
            <label class="form-label">
              <v-icon small color="#023449" class="mr-1">mdi-eye</v-icon>
              Preview
            </label>
            <v-card outlined class="preview-card">
              <v-card-text class="pa-4 text-center">
                <v-chip
                    :color="formulario.cor"
                    dark
                    large
                    class="preview-chip"
                >
                  <v-icon left>{{ formulario.icone || 'mdi-help-circle' }}</v-icon>
                  {{ formulario.nome || 'Nome da Categoria' }}
                </v-chip>
              </v-card-text>
            </v-card>
          </div>

        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Ações -->
      <v-card-actions class="pa-4 dialog-actions">
        <v-btn
            text
            color="#64748b"
            @click="fechar"
            :disabled="salvando"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            color="#023449"
            dark
            @click="salvar"
            :loading="salvando"
            :disabled="!formularioValido || salvando"
            class="px-6"
        >
          <v-icon left small>mdi-content-save</v-icon>
          {{ modoEdicao ? 'Atualizar' : 'Salvar' }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Snackbar -->
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="3000"
        bottom
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import IconPicker from '../Widgets/IconPicker.vue'
import { mapState } from 'vuex'

export default {
  name: 'CategoriaFormulario',

  components: {
    IconPicker
  },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    categoria: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      dialogInterno: false,
      formularioValido: false,
      salvando: false,
      menuCor: false,
      erroIcone: '',

      formulario: {
        nome: '',
        cor: '#2196F3',
        icone: ''
      },

      regras: {
        nome: [
          v => !!v || 'Nome é obrigatório',
          v => (v && v.length <= 100) || 'Nome deve ter no máximo 100 caracteres',
          v => (v && v.trim().length > 0) || 'Nome não pode ser vazio'
        ],
        cor: [
          v => !!v || 'Cor é obrigatória',
          v => /^#[0-9A-F]{6}$/i.test(v) || 'Cor deve estar no formato #RRGGBB'
        ]
      },

      coresSugeridas: [
        [
          '#F44336', // Red
          '#E91E63', // Pink
          '#9C27B0', // Purple
          '#673AB7', // Deep Purple
          '#3F51B5', // Indigo
          '#2196F3', // Blue
          '#03A9F4', // Light Blue
          '#00BCD4', // Cyan
          '#009688', // Teal
          '#4CAF50', // Green
          '#8BC34A', // Light Green
          '#CDDC39', // Lime
          '#FFEB3B', // Yellow
          '#FFC107', // Amber
          '#FF9800', // Orange
          '#FF5722', // Deep Orange
          '#795548', // Brown
          '#607D8B'  // Blue Grey
        ]
      ],

      snackbar: {
        show: false,
        message: '',
        color: 'success'
      }
    }
  },

  computed: {
    ...mapState(["backendUrl"]),

    modoEdicao() {
      return !!(this.categoria && this.categoria.id)
    }
  },

  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        this.dialogInterno = val
        if (val) {
          this.carregarCategoria()
        }
      }
    },

    dialogInterno(val) {
      if (!val) {
        this.$emit('update:dialog', false)
      }
    },

    'formulario.icone'(val) {
      if (val) {
        this.erroIcone = ''
      }
    }
  },

  methods: {
    carregarCategoria() {
      if (this.modoEdicao) {
        this.formulario = {
          nome: this.categoria.nome || '',
          cor: this.categoria.cor || '#2196F3',
          icone: this.categoria.icone || ''
        }
      } else {
        this.resetFormulario()
      }

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      })
    },

    resetFormulario() {
      this.formulario = {
        nome: '',
        cor: '#2196F3',
        icone: ''
      }
      this.erroIcone = ''
    },

    validarIcone() {
      if (!this.formulario.icone || this.formulario.icone.trim() === '') {
        this.erroIcone = 'Ícone é obrigatório'
        return false
      }
      this.erroIcone = ''
      return true
    },

    async salvar() {
      // Validar formulário
      if (!this.$refs.form.validate()) {
        this.mostrarSnackbar('Por favor, corrija os erros no formulário', 'warning')
        return
      }

      // Validar ícone
      if (!this.validarIcone()) {
        this.mostrarSnackbar('Por favor, selecione um ícone', 'warning')
        return
      }

      this.salvando = true

      try {
        const payload = {
          acao: this.modoEdicao ? 'atualizar' : 'criar',
          nome: this.formulario.nome.trim(),
          cor: this.formulario.cor.toUpperCase(),
          icone: this.formulario.icone
        }

        if (this.modoEdicao) {
          payload.id = this.categoria.id
        }

        const response = await axios.post(`${this.backendUrl}normativa/categoria`, payload)

        this.mostrarSnackbar(
            this.modoEdicao
                ? 'Categoria atualizada com sucesso!'
                : 'Categoria criada com sucesso!',
            'success'
        )

        this.$emit('salvo', response.data)

        setTimeout(() => {
          this.fechar()
        }, 500)

      } catch (error) {
        console.error('Erro ao salvar categoria:', error)

        const mensagemErro = error.response?.data?.erro
            || error.message
            || 'Erro ao salvar categoria'

        this.mostrarSnackbar(mensagemErro, 'error')
      } finally {
        this.salvando = false
      }
    },

    fechar() {
      if (!this.salvando) {
        this.dialogInterno = false
        this.$emit('fechar')

        setTimeout(() => {
          this.resetFormulario()
          if (this.$refs.form) {
            this.$refs.form.resetValidation()
          }
        }, 300)
      }
    },

    mostrarSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.color = color
      this.snackbar.show = true
    }
  }
}
</script>

<style scoped>
.form-dialog {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Dialog Header */
.dialog-header {
  background: linear-gradient(135deg, #023449 0%, #034d6b 100%);
  color: white;
}

.icon-wrapper-medium {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  letter-spacing: -0.01em;
}

/* Form Content */
.form-content {
  max-height: calc(80vh - 140px);
  overflow-y: auto;
}

.form-group {
  margin-bottom: 24px;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #023449;
  display: block;
  margin-bottom: 8px;
  letter-spacing: -0.01em;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

.field-hint {
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 6px;
  line-height: 1.4;
}

/* Color Picker */
.color-picker-card {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.color-button {
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.2s ease;
}

.color-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
}

.color-preview-small {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: 2px solid #e2e8f0;
  margin-right: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.color-swatches-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.color-swatches {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.swatch-button {
  border-radius: 8px !important;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.swatch-button:hover {
  transform: scale(1.1);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
}

/* Preview Card */
.preview-card {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.preview-chip {
  border-radius: 12px !important;
  font-weight: 600;
  font-size: 1rem !important;
  padding: 24px 32px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Dialog Actions */
.dialog-actions {
  background-color: #fafafa;
}

/* Text Fields */
::v-deep .v-text-field--outlined fieldset {
  border-color: #e2e8f0;
}

::v-deep .v-text-field--outlined:hover fieldset {
  border-color: #023449;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #023449;
  border-width: 2px;
}

::v-deep .v-text-field input {
  font-size: 0.938rem;
  color: #1e293b;
}

::v-deep .v-text-field .v-label {
  font-size: 0.875rem;
  color: #64748b;
}

::v-deep .v-counter {
  font-size: 0.75rem;
  color: #94a3b8;
}

/* Color Picker Adjustments */
::v-deep .v-color-picker {
  max-width: 100%;
}

::v-deep .v-color-picker__controls {
  padding: 8px;
}

/* Scrollbar */
.form-content::-webkit-scrollbar {
  width: 8px;
}

.form-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.form-content::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 4px;
}

.form-content::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* Responsive */
@media (max-width: 600px) {
  .header-title {
    font-size: 1.125rem;
  }

  .color-button {
    height: 50px !important;
    width: 50px !important;
  }

  .preview-chip {
    padding: 20px 24px !important;
    font-size: 0.938rem !important;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .color-button,
  .swatch-button {
    transition: none !important;
  }
}
</style>